import React from 'react';
import Icon from 'components/Icon/Icon.react';
import styles from 'dashboard/Apps/AppsIndex.scss';

const Empty = ({ footerContent, className }) => {
  return (
    <div className={className}>
      <div className={styles.holder}>
        <div className={styles.empty}>
          <h1>Welcome on SashiDo!</h1>
          <h2>We are eager to see what amazing apps you're about to create.</h2>

          <div className={styles.features}>
            <div>
              <span><Icon width={20} height={20} name="icon-check" colored />Push Notifications</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Advanced Cloud Code</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Background Jobs</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Webhooks</span>
              <span><Icon width={20} height={20} name="icon-check" colored />LiveQueries</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Advanced Logs</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Social Logins</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Email Integration</span>
            </div>
            <div>
              <span><Icon width={20} height={20} name="icon-check" colored />Auto-Scaling</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Multi-Geo Coverage</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Database Optimization</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Database Access</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Static Web Site Hosting</span>
              <span><Icon width={20} height={20} name="icon-check" colored />NodeJS App Hosting</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Free Private GitHub Repository</span>
              <span><Icon width={20} height={20} name="icon-check" colored />Migration from any Parse Server</span>
            </div>
          </div>

          {footerContent}
        </div>
      </div>
    </div>
  )
}

export default Empty;
